import axios from '@/api/config';

const policy = {
  getPolicyById(data) {
    return axios.get(`${process.env.BASE_URL}/policy/getPolicyById/` + data, {});
  },
  getPolicyDetail(data) {
    return axios.get(`${process.env.BASE_URL}/policy/getPolicyDetail`, {params: data});
  },
  getPolicy(data) {
    return axios.get(`${process.env.BASE_URL}/policy/getPolicy`, {params: data});
  },
  getPolicyList(data) {
    return axios.get(`${process.env.BASE_URL}/policy/getPolicyList`, {params: data});
  },

  //  城市
    getPolicyCity(data){
        return axios.get(`${process.env.BASE_URL}/dictionary/getDictionaryListProvinceAndCity`, {params: data});
    },
  getPolicyTree(data) {
    return axios.get(`${process.env.BASE_URL}/policy/getPolicyTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/policy/pageList`, data);
  },
  addPolicy(data) {
    return axios.post(`${process.env.BASE_URL}/policy/addPolicy`, data);
  },
  updatePolicy(data) {
    return axios.put(`${process.env.BASE_URL}/policy/updatePolicy`, data);
  },
  deletePolicy(data) {
    return axios.delete(`${process.env.BASE_URL}/policy/deletePolicy`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/policy/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/policy/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/policy/active`, data);
  },
}

export default policy;



// WEBPACK FOOTER //
// ./src/api/policy.js